import React from 'react'
import Link from 'gatsby-link'
import logo from '../../img/logo.png'

const Footer = ({ siteTitle }) => (
  <footer className="py-4 py-md-5 bg-light border-top">
    <div className="container">
      <div className="row">
        <div className="col col-md">
          <h5>Company</h5>
          <ul className="list-unstyled text-small">
            <li>
              <a target="_blank" href="https://www.basecanvas.com">
                About Us
              </a>
            </li>
          </ul>
        </div>
        <div className="col col-md">
          <h5>Support</h5>
          <ul className="list-unstyled text-small">
            <li>
              <a href="mailto:david@duplidocs.com">Contact Us</a>
            </li>
          </ul>
        </div>
        <div className="col col-md">
          <h5>Legal</h5>
          <ul className="list-unstyled text-small">
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/cookies-policy">Cookies Policy</Link>
            </li>
            <li>
              <Link to="/terms">Terms of Service</Link>
            </li>
          </ul>
        </div>
        <div className="col col-md">
          <img className="mb-2" src={logo} alt="" height="35" />
          <small className="d-block mb-3 text-muted">
            DupliDocs<br />
            Created with love by Duplidocs AB
          </small>
          <small className="d-block mb-3 text-muted">© 2017-2018</small>
        </div>
      </div>
    </div>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/footer.js